import { Box, Typography } from "@material-ui/core";
import { Grid, styled } from "@mui/material";
import { useRouter } from "next/router";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { MemoizedButton } from "../../SDK/button";
import { imagesList } from "../../constants";
import { primary } from "../../constants/theme";

const CustomReferalSuccess = styled(Box)(({ theme }) => ({
  ".heading-success": {
    fontSize: "24px",
    lineHeight: "30px",
  },
  ".congrats": {
    fontSize: "30px",
    lineHeight: "40px",
    marginTop: "10px",
    color: primary.main,
  },
  ".desc-success": {
    fontSize: "18px",
    lineHeight: "24px",
    width: "75%",
    margin: "10px auto",
  },
  button: {
    width: "50%",
    marginTop: "20px",
  },
  [theme.breakpoints.down("md")]: {
    ".heading-success": {
      fontSize: "18px",
      lineHeight: "30px",
    },
    ".congrats": {
      fontSize: "24px",
      lineHeight: "40px",
    },
    ".desc-success": {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
}));

const ReferralConfirmation = () => {
  const navigate = useRouter();
  return (
    <CustomReferalSuccess>
      <Grid container spacing={2} sx={{ alignItems: "center" }}>
        <Grid sx={{ display: "block" }} item xs={12} md={6}>
          <LazyLoadImage
            src={imagesList.referralSuccess}
            alt="Refer and earn"
            effect="opacity"
            className="image-refer-and-earn"
            width="100%"
          />
        </Grid>
        <Grid
          sx={{ display: "block", textAlign: "center" }}
          item
          xs={12}
          md={6}
        >
          <Typography className="heading-success">
            Referral details sent
          </Typography>
          <Typography className="congrats"> 🎊Congratulations! 🎊</Typography>
          <Typography className="desc-success">
            You referral has been submitted. The referral bonus will be issued
            once your referral purchases through Turno!
          </Typography>
          <MemoizedButton
            content={"Back to home"}
            handleClick={() => {
              navigate.push("/");
            }}
          />
        </Grid>
      </Grid>
    </CustomReferalSuccess>
  );
};

export default ReferralConfirmation;
export const MemoizedReferralConfirmation = React.memo(ReferralConfirmation);
